import LivraisonPlanifieeLivreeController from './livraison.planifiee.livree.controller';

export default {
    template: require('./livraison.planifiee.livree.html'),
    controller: LivraisonPlanifieeLivreeController
};
